import store from "@/store";
import COLLECTION_NAMES from "@/assets/js/constants/collection_names";

export default {
  async created() {
    store.dispatch('breadcrumbs/setBreadcrumbs', [
      {displayName: 'マイページ', path: {name: 'MypageTop', params: ''}},
      {displayName: 'ユーザー情報確認', path: {name: 'UserDetail', params: ''}}
    ]);

    await this.getDoc(
      COLLECTION_NAMES.USER_DETAILS,
      this.uid,
      {}).then(userDetail => {
      if (!userDetail.skills || !userDetail.softwares) this.$router.push({name: 'RegisterUserSkill'});
    }).catch(() => {
      // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
    });
  },
}